module.exports = __webpack_public_path__ + "static/media/l_2_7.28baf28e.png";